import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-leilao08',
  templateUrl: './leilao08.component.html',
  styleUrls: ['./leilao08.component.scss']
})
export class Leilao08Component implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
  }

  voltar(){
    this.router.navigate([''], { relativeTo: this.route });
  }

}
